export enum MAIN_SCREEN_LIST {
  INITIAL = 'initialScreen'
}

export enum MAIN_REQUEST_ID_LIST {
  GET_MASTER_DATA = 'GET_MASTER_DATA',
  CALL_MASTER_DATA_AND_LANDING_STATUS = 'CALL_MASTER_DATA_AND_LANDING_STATUS',
  POST_CONFIRM_ALL_CHANGE = 'POST_CONFIRM_ALL_CHANGE',
  GET_PRELOAD = 'GET_PRELOAD'
}

export enum COMFIRM_ALL_CHANGE {
  NO_VAT_ADDRESS = 'confirmAllChange.noVatAddress',
  NO_MENU = 'confirmAllChange.noMenu'
}

export enum MASTER_DATA_TYPE {
  BLANK,
  FAIL,
  SUCCESS
}

export enum SQC_STATUS {
  SQC_APPROVE = 'SQC-APPROVE',
  SQC_REJECT = 'SQC-REJECT',
  SQC_NEW = 'SQC-NEW',
  SQC_PENDING_CAN_SELL = 'SQC-CANSELL',
  SQC_PENDING_CANNOT_SELL = 'SQC-CANNOTSELL',
}

export enum MERCHANT_TYPE {
  INDIVIDUAL = 1,
  JURISTIC = 2
}

export enum BUSINESS_TYPE {
  FOOD = 1,
  MART = 2
}

export enum SCREEN_TYPE {
  BRANCH_MANAGEMENT = 1,
  USER_MANAGEMENT = 2,
  VAT_ADDRESS = 3,
  CATEGORY = 4,
  PRODUCT_MENU = 5,
  REPORT = 6,
  LOGOUT = 7,
  DEVICE_MANAGEMENT = 8,
}
